import Header from './Header';
import Footer from './Footer';
import {Helmet} from 'react-helmet';
import { useState } from 'react';
import { SendPhoneCode, BindPhone } from './libs/api';

import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import * as React from 'react';
import {useTranslation} from "react-i18next";

const timeNum = 120;
export default function InfoPhone() {
  const { t } = useTranslation();

  const phoneAreaList = [
    { name: '+86', value: '+86' },
    { name: '+861', value: '+861' },
    { name: '+862', value: '+862' },
    { name: '+863', value: '+863' },
    { name: '+864', value: '+864' },
    { name: '+865', value: '+865' },
    { name: '+866', value: '+866' },
  ];
  const [phoneArea, setPhoneArea] = React.useState(phoneAreaList[0].value);
  const [validMsgPhone, setValidMsgPhone] = useState('');
  const [validMsgCode, setValidMsgCode] = useState('');
  const [isClickPhone, setIsClickPhone] = useState(false);
  const [isClickPhoneMsg, setIsClickPhoneMsg] = useState('GET CODE');
  const [isClickPhoneNum, setIsClickPhoneNum] = useState(timeNum);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (event: SelectChangeEvent) => {
    setPhoneArea(event.target.value);
  };

  function SelectIcon(e: any) {
    if (e.className.includes('MuiSelect-iconOpen')) {
      return (
        <div className="MuiOutlinedInput-select-icon">
          <div
            style={{
              width: '0.5rem',
              height: '0.5rem',
              transform: 'rotate(45deg)',
              borderLeft: '1px solid #00FFFF',
              borderTop: '1px solid #00FFFF',
              position: 'relative',
              top: '',
            }}
          ></div>
        </div>
      );
    }
    return (
      <div className="MuiOutlinedInput-select-icon">
        <div
          style={{
            width: '0.5rem',
            height: '0.5rem',
            transform: 'rotate(45deg)',
            borderRight: '1px solid #00FFFF',
            borderBottom: '1px solid #00FFFF',
            position: 'relative',
            top: '-0.25rem',
          }}
        ></div>
      </div>
    );
  }

  function validPhone() {
    // @ts-ignore
    const val = document.querySelector('#phone').value.trim();
    if (val === 'null' || val === 'undefined' || val === '' || !val) {
      setValidMsgPhone(t("validate.information"));
      return false;
    }
    if (/^\d+$/gi.test(val)) {
      setValidMsgPhone('');
      return true;
    } else {
      setValidMsgPhone(t("validate.number"));
      return false;
    }
  }
  function validPhoneArea() {
    // @ts-ignore
    const val = document.querySelector('#phoneArea').value.trim();
    if (val === 'null' || val === 'undefined' || val === '' || !val) {
      setValidMsgPhone(t("validate.information"));
      return false;
    }
    if (/^\d+$/gi.test(val)) {
      setValidMsgPhone('');
      return true;
    } else {
      setValidMsgPhone(t("validate.number"));
      return false;
    }
  }
  function validCode() {
    // @ts-ignore
    const val = document.querySelector('#phoneCode').value.trim();
    if (val === 'null' || val === 'undefined' || val === '' || !val) {
      setValidMsgCode(t("validate.information"));
      return false;
    }
    if (/^\d{6}$/gi.test(val)) {
      setValidMsgCode('');
      return true;
    } else {
      setValidMsgCode(t("validate.number"));
      return false;
    }
  }
  function sendCode() {
    if (validPhoneArea() && validPhone()) {
      // @ts-ignore
      const phoneArea = document.querySelector('#phoneArea').value.trim();
      // @ts-ignore
      const phone = document.querySelector('#phone').value.trim();
      if (!validPhone()) {
        return false;
      }
      setValidMsgCode('');
      SendPhoneCode({
        phone: phone,
        areaCode: phoneArea,
      }).then(() => {
        let time = timeNum;
        setIsClickPhone(true);
        const interval = setInterval(() => {
          setIsClickPhoneNum(time--);
          setIsClickPhoneMsg(time + 's');
          if (time < 0) {
            setIsClickPhone(false);
            setIsClickPhoneNum(timeNum);
            setIsClickPhoneMsg('GET CODE');
            clearInterval(interval);
          }
        }, 1000);
      });
      return true;
    }
  }
  function bindPhone() {
    if (validPhoneArea() && validPhone() && validCode()) {
      // @ts-ignore
      const phoneArea = document.querySelector('#phoneArea').value.trim();
      // @ts-ignore
      const phone = document.querySelector('#phone').value.trim();
      // @ts-ignore
      const phoneCode = document.querySelector('#phoneCode').value.trim();
      setIsLoading(true);
      BindPhone({
        phone: phone,
        areaCode: phoneArea,
        phoneCode: phoneCode,
      })
        .then((res: any) => {
          setIsLoading(false);
          if (!res.code) {
            toHome();
          }
        })
        .catch(() => {});
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  }
  function toHome() {
    const redirectUrl = window.location.href.split('redirect=')[1];
    if (
      redirectUrl &&
      !(redirectUrl.includes('forgot') || redirectUrl.includes('reset'))
    ) {
      if (redirectUrl.indexOf(".") > -1) {
        window.self.location.href = redirectUrl;
      } else {
        window.self.location.href = window.location.origin + redirectUrl;
      }
    } else {
      window.self.location.href = window.location.origin;
    }
  }
  return (
    <>
      <Helmet>
        <title>
          DIGITAL ASSETs for MetaGaia & HexaHero: Purchase & Mint MetaGaia DIGITAL ASSETs
        </title>
        <meta
          name="description"
          content="Discover all 9 Heroes, each Hero Collection has 1000 DIGITAL ASSET cards with 5 rarity levels and different in-game stats. Stay tuned for information on upcoming drops."
        />
        <meta
          property="og:description"
          content="Discover all 9 Heroes, each Hero Collection has 1000 DIGITAL ASSET cards with 5 rarity levels and different in-game stats. Stay tuned for information on upcoming drops."
        />
      </Helmet>
      <div className="bg-hexahero">
        <div className="wrapper">
          <Header />
          <main>
            <section className="s-nft s-default">
              <img
                className="img-bg"
                src="./assets/images/bg1.png?v=20230413001"
                data-anchor-target=".s-nft"
                data-center="transform: translateY(0%)"
                data-top-bottom="transform: translateY(0%)"
              />

              <div className="container">
                <h2 className="txt-default-title wow fadeInUp bind-phone-title">
                  <span className="txt">{t("page.phone.SMS")}</span>
                </h2>
                <h5 className="txt-default-title wow fadeInUp bind-phone-title-sub">
                  <span className="txt">
                    {t("page.phone.You")}{' '}
                  </span>
                </h5>
                <div className="s-flex s-flex-center-row">
                  <div className="row form-box bind-phone">
                    <div className="login-ct">
                      <div className="col col-12 form-item">
                        <div className="form-label">{t("page.phone.Phone")}</div>
                        <div className="s-flex s-flex-between-row form-value">
                          <div className=" btn-border-none s-flex s-flex-between-row">
                            <div>+</div>
                            <input
                              type="text"
                              id="phoneArea"
                              minLength={1}
                              maxLength={5}
                              placeholder=""
                              onBlur={validPhoneArea}
                            />
                            <div
                              style={{
                                width: '1px',
                                height: '2rem',
                                backgroundColor: '#00FFFF',
                              }}
                            ></div>
                          </div>
                          <input
                            type="phone"
                            id="phone"
                            minLength={1}
                            maxLength={15}
                            placeholder=""
                            onBlur={validPhone}
                          />
                        </div>
                        <div className="form-valid">{validMsgPhone}</div>
                      </div>
                      <div className="col col-12 form-item">
                        <div className="form-label">{t("page.phone.Confirm")}</div>
                        <div className="s-flex s-flex-between-row form-value">
                          <button
                            className="btn btn-default btn-border-none"
                            onClick={sendCode}
                            disabled={isClickPhone}
                          >
                            {isClickPhoneMsg}
                          </button>
                          <input
                            type="text"
                            id="phoneCode"
                            minLength={6}
                            maxLength={6}
                            placeholder={t("placeholder.Code")}
                            onBlur={validCode}
                          />
                        </div>
                        <div className="form-valid">{validMsgCode}</div>
                      </div>
                      <div className="s-flex s-flex-center-row">
                        <button
                          onClick={bindPhone}
                          className="btn btn-default btn-form-login btn-from-bind-phone"
                          disabled={isLoading}
                        >
                          {t("button.CONFIRM")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <Footer />
          </main>
        </div>
      </div>
    </>
  );
}
